// material-ui
import {} from '@mui/material'
import * as firebaseapp from 'features/firebase-app'

import { CircularProgress } from '@mui/material'
import TitleService from 'title-service'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import ProfileHeader from 'components/ProfileHeader'
import ProfileList from 'components/ProfileList'
import ProfileScene from 'components/ProfileScene'
import ProfileSection from 'components/ProfileSection'
import ProfileSectionContainer from 'components/ProfileSectionContainer'
import { getUserClaims } from 'features/application/application-slice'
import { is_genericResult_busy } from 'features/genericResult/genericResult-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let genericResult_busy = useSelector(is_genericResult_busy)

  useEffect(() => {
    if (claims?.fire_user && getMobileConnect()) {
      dispatch(
        autoThunks.connect_mobile_login({
          userId: true,
          firebaseId: true,
          callback: (success: boolean, res: any) => {
            if (success) {
              onSuccess(success, res)
            } else {
              onFail()
            }
          },
        }),
      )
    }
  }, [claims?.fire_user])

  function getMobileConnect() {
    return firebaseapp.getAppDataStore('mobile')
  }

  function onSuccess() {
    window.location.hash = '#success'
  }

  function onFail() {
    window.location.hash = '#success=false'
  }

  function main(comp: any): any {
    return (() => {
      return (
        <div className="profile component">
          <ProfileScene>
            <ProfileHeader
              btnTitle={TitleService('Back')}
              onBtnClick={() => {
                history.back()
              }}
            ></ProfileHeader>
            <ProfileSectionContainer>
              <ProfileSection>
                <h2 className="padding--bottom-6 text-color--primary ">
                  {TitleService('Connecting')}
                </h2>
                <ProfileList>
                  <div style={{}}>
                    {!genericResult_busy ? null : (
                      <CircularProgress size={'6rem'} />
                    )}
                  </div>
                </ProfileList>
              </ProfileSection>
            </ProfileSectionContainer>
          </ProfileScene>
        </div>
      )
    })()
  }

  let output_main = main(null)

  return output_main
}
